module.exports = __webpack_public_path__ + "img/csc.2b7aa901.png";